import { CoverType } from 'scenes/common/types';
import {
  BuildingAndContentsDiscount,
  BuildingAndContentsDiscountRelated,
  BuildingDiscount,
  CommonDiscountRelated,
  ContentsDiscount,
} from './DiscountContent';

export const discountContent: {
  [key in CoverType]: JSX.Element[];
} = {
  [CoverType.Building]: [BuildingDiscount(), CommonDiscountRelated()],
  [CoverType.BuildingAndContents]: [
    BuildingAndContentsDiscount(),
    BuildingAndContentsDiscountRelated(),
  ],
  [CoverType.Contents]: [ContentsDiscount(), CommonDiscountRelated()],
  [CoverType.Unspecified]: [],
};

export const getDiscountCopy = (coverType: CoverType): JSX.Element =>
  discountContent[coverType][0];

export const getDiscountReleatedCopy = (coverType: CoverType): JSX.Element =>
  discountContent[coverType][1];
